import { put, takeLatest, call } from 'redux-saga/effects';

import * as actions from './actions';
import * as types from './types';
import * as service from './service';

function* fetchEventsPage(action: any) {
    try {
        const params = action.payload;
        const data = yield call(service.fetchEventsPage, params);

        yield put(actions.fetchEventsSuccess(data, params));
    } catch (error) {
        yield put(actions.fetchEventsError(error.message));
    }
}

function* fetchEventsFilters() {
    try {
        const data = yield call(service.fetchEventsFilters);

        yield put(actions.fetchEventsFiltersSuccess(data));
    } catch (error) {
        yield put(actions.fetchEventsFiltersError(error.message));
    }
}

export default function* appSaga() {
    yield takeLatest(types.FETCH_EVENTS_PAGE, fetchEventsPage);
    yield takeLatest(types.FETCH_EVENTS_FILTERS, fetchEventsFilters);
}
